export const mapToFilterOptions = <T extends { id: string; label: string }>(
  list?: T[],
) => list?.map((item) => ({ label: item.label, value: item.id })) ?? [];
